import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { AuthGate } from "@/components/AuthGate";
import { useGuestMode } from "@/hooks/useGuestMode";

interface MemberRouteProps {
  icon: LucideIcon;
  title: string;
  description: string;
  children: ReactNode;
}

/**
 * Route-level gate. Guests get the theatrical AuthGate instead of a page that
 * would render empty (or fail against RLS) without a session.
 */
export const MemberRoute = ({ icon, title, description, children }: MemberRouteProps) => {
  const { isGuest, authReady } = useGuestMode();

  if (!authReady) return null;
  if (isGuest) return <AuthGate icon={icon} title={title} description={description} />;
  return <>{children}</>;
};

export default MemberRoute;
